import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/tools/ToolShell";

export const Route = createFileRoute("/pt-br/terms-of-use")({
  head: () => ({
    meta: [
      { title: "Termos de Uso — Picamini.online" },
      {
        name: "description",
        content: "Termos de uso e condições do Picamini.online.",
      },
    ],
    links: [
      { rel: "canonical", href: "https://picamini.online/pt-br/termos-de-uso" },
      { rel: "alternate", hrefLang: "en", href: "https://picamini.online/terms-of-use" },
      { rel: "alternate", hrefLang: "es", href: "https://picamini.online/es/terminos-de-uso" },
      { rel: "alternate", hrefLang: "de", href: "https://picamini.online/de/nutzungsbedingungen" },
      { rel: "alternate", hrefLang: "pt-BR", href: "https://picamini.online/pt-br/termos-de-uso" },
      { rel: "alternate", hrefLang: "x-default", href: "https://picamini.online/terms-of-use" },
    ],
  }),
  component: PtBrTermsPage,
});

function PtBrTermsPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col font-sans">
      <SiteHeader lang="pt-BR" />

      <main className="flex-1 py-12 mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 space-y-6">
        <h1 className="text-3xl font-extrabold text-foreground">Termos de Uso</h1>
        <p className="text-sm text-muted-foreground">Última atualização: Setembro de 2026</p>

        <p className="text-base text-muted-foreground leading-relaxed">
          Ao acessar e utilizar o site <strong>Picamini.online</strong>, você concorda em cumprir os seguintes termos e condições de uso.
        </p>

        <h2 className="text-xl font-bold text-foreground pt-3">1. Uso Gratuito e Licença</h2>
        <p className="text-base text-muted-foreground leading-relaxed">
          Todas as ferramentas disponibilizadas no Picamini.online são gratuitas para uso pessoal, educacional ou comercial. É proibido tentar clonar ou fazer engenharia reversa do código das ferramentas.
        </p>

        <h2 className="text-xl font-bold text-foreground pt-3">2. Responsabilidade do Usuário</h2>
        <p className="text-base text-muted-foreground leading-relaxed">
          Você é o único responsável pelos arquivos e conteúdos processados por meio das nossas ferramentas. Como não armazenamos seus arquivos em nossos servidores, não mantemos cópias nem backups dos documentos editados.
        </p>
      </main>

      <SiteFooter lang="pt-BR" />
    </div>
  );
}
